<form [formGroup]="formGroup">
  @for (element of elements; track element) {
    @if (element.type === "text") {
      <div>
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div
            fxLayout="col"
            fxFlex="100"
            class="add-patient-col"
            fxLayoutAlign="start center"
          >
            <b class="title">{{ getQuestionTitle(element.title) }}</b>
            @if (!readonlyMode && (isInpatientView() || isEOC())) {
              <button
                nz-button
                nzType="primary"
                type="button"
                (click)="setNotMentioned(element.name)"
                class="quick-button"
                [disabled]="!hasPermission(['a-sqa'])"
              >
                {{ "Not mentioned" | translate }}
              </button>
            }
          </div>
        </div>
        @if (getQuestionInstruction(element.title)) {
          <div class="instruction-row">
            <div fxLayout="col" fxFlex="100" class="add-patient-col">
              <div class="question-instruction">
                {{ getQuestionInstruction(element.title) }}
              </div>
            </div>
          </div>
        }
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="add-patient-row"
        >
          <div fxLayout="col" fxFlex="100" class="add-patient-col">
            <input
              type="text"
              class="add-patient-input"
              [formControlName]="element.name"
            />
          </div>
        </div>
      </div>
    }

    @if (element.type === "boolean") {
      <div class="q-row">
        <div class="q-label">
          <b class="title">{{ getQuestionTitle(element.title) }}</b>
          @if (getQuestionInstruction(element.title)) {
            <div class="question-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="q-control a-index">
          <nz-radio-group
            class="boolean-segment"
            [nzButtonStyle]="'solid'"
            [formControlName]="element.name"
          >
            <label
              nz-radio-button
              [nzValue]="false"
              (click)="onRadioClick(element.name, false)"
            >
              <span>{{ element.labelFalse }}</span>
            </label>

            <label
              nz-radio-button
              [nzValue]="true"
              (click)="onRadioClick(element.name, true)"
            >
              <span>{{ element.labelTrue }}</span>
            </label>
          </nz-radio-group>
        </div>
      </div>
    }

    @if (element.type === "comment") {
      <div>
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div
            fxLayout="col"
            fxFlex="100"
            class="add-patient-col"
            fxLayoutAlign="start center"
          >
            <b class="title">{{ getQuestionTitle(element.title) }}</b>
            @if (!readonlyMode && (isInpatientView() || isEOC())) {
              <button
                nz-button
                nzType="primary"
                type="button"
                (click)="setNotMentioned(element.name)"
                class="quick-button"
                [disabled]="!hasPermission(['a-sqa'])"
              >
                {{ "Not mentioned" | translate }}
              </button>
            }
          </div>
        </div>
        @if (getQuestionInstruction(element.title)) {
          <div class="instruction-row">
            <div fxLayout="col" fxFlex="100" class="add-patient-col">
              <div class="question-instruction">
                {{ getQuestionInstruction(element.title) }}
              </div>
            </div>
          </div>
        }
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="add-patient-row"
        >
          <div fxLayout="col" fxFlex="100" class="add-patient-col">
            <textarea
              class="add-patient-input textarea-input"
              [formControlName]="element.name"
            ></textarea>
          </div>
        </div>
      </div>
    }

    @if (element.type === "radiogroup") {
      <div>
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div
            fxLayout="col"
            fxFlex="100"
            class="add-patient-col"
            fxLayoutAlign="start center"
          >
            <b class="title">{{ getQuestionTitle(element.title) }}</b>
          </div>
        </div>
        @if (getQuestionInstruction(element.title)) {
          <div class="instruction-row">
            <div fxLayout="col" fxFlex="100" class="add-patient-col">
              <div class="question-instruction">
                {{ getQuestionInstruction(element.title) }}
              </div>
            </div>
          </div>
        }
        <div
          fxLayout="column"
          fxLayoutAlign="start start"
          class="add-patient-row radio-button-list"
        >
          @for (choice of element.choices; track choice) {
            <div fxLayout="col" fxFlex="100" class="add-patient-col">
              <label class="radio-label">
                <input
                  type="radio"
                  [formControlName]="element.name"
                  [value]="choice.value"
                  (click)="onRadioClick(element.name, choice.value)"
                />
                <span>{{ getChoiceLabel(choice) }}</span>
              </label>
            </div>
          }
        </div>
      </div>
    }

    @if (element.type === "checkbox") {
      <div>
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div
            fxLayout="col"
            fxFlex="100"
            class="add-patient-col"
            fxLayoutAlign="start center"
          >
            <b class="title">{{ getQuestionTitle(element.title) }}</b>
          </div>
        </div>
        @if (getQuestionInstruction(element.title)) {
          <div class="instruction-row">
            <div fxLayout="col" fxFlex="100" class="add-patient-col">
              <div class="question-instruction">
                {{ getQuestionInstruction(element.title) }}
              </div>
            </div>
          </div>
        }
        <div
          fxLayout="column"
          fxLayoutAlign="start start"
          class="add-patient-row checkbox-list"
        >
          @for (choice of element.choices; track choice) {
            <div fxLayout="col" fxFlex="100" class="add-patient-col">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  [checked]="isCheckboxSelected(element.name, choice.value)"
                  (change)="
                    onCheckboxChange(
                      element.name,
                      choice.value,
                      $any($event.target).checked
                    )
                  "
                />
                <span>{{ getChoiceLabel(choice) }}</span>
              </label>
            </div>
          }
        </div>
      </div>
    }
  }
</form>
